module.exports = __webpack_public_path__ + "fonts/MTSWide-Medium.cd070df.woff2";